import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { SERVICE_PHONE_02, SERVICE_EMAIL_02 } from '../utils/constant'
import ETooltip from '../themes/components/ETooltip'

const useStyles = makeStyles((theme) =>
  createStyles({
    toolTip: {
      marginLeft: 'auto',
    },
  }),
)
const BookingTips = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <ETooltip
      className={classes.toolTip}
      title={
        <Typography variant="caption" color="inherit">
          {t('tips.main_tips')}:
          <br />
          1、{t('tips.appointment_tips_list.1')}
          <br />
          2、{t('tips.appointment_tips_list.2')}
          <br />
          3、{t('tips.appointment_tips_list.3')}
          <br />
          4、{t('tips.appointment_tips_list.4', { phone: SERVICE_PHONE_02, email: SERVICE_EMAIL_02 })}
          <br />
          5、{t('tips.appointment_tips_list.5', { phone: SERVICE_PHONE_02 })}
        </Typography>
      }
    >
      <ErrorOutlineIcon color="primary" />
    </ETooltip>
  )
}

export default BookingTips
